// extracted by mini-css-extract-plugin
export default {"container":"Auction_container__vUSqj"};